module.exports = __webpack_public_path__ + "img/information_inspiring_design@2x.5de2afa.webp";